export abstract class NgAnalyticsService {
    abstract initialize(): Promise<any>;
    abstract enable(): Promise<any>;
    abstract disable(): Promise<any>;
    abstract toggle(status: boolean): Promise<any>;
    abstract trackEvent(event: string, properties?: { [key: string]: string }): Promise<any>;
    abstract setScreenName(screenName: string, nameOverride?: string):  Promise<any>;
    abstract setUserProperty(properties: { name: string, value: string }): Promise<any>;
    abstract setUserId(id: number): Promise<any>;
}
